import { render, staticRenderFns } from "./CustomerDueWithPDCTablePromo.vue?vue&type=template&id=fd6addf8"
import script from "./CustomerDueWithPDCTablePromo.vue?vue&type=script&lang=ts"
export * from "./CustomerDueWithPDCTablePromo.vue?vue&type=script&lang=ts"
import style0 from "./CustomerDueWithPDCTablePromo.vue?vue&type=style&index=0&id=fd6addf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports